import Swiper from "swiper";
import { Pagination, Mousewheel, Navigation } from "swiper/modules";

const slider = () => {
  const aboutSlider = new Swiper(".js-about-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    modules: [Pagination, Mousewheel],
    mousewheel: {
      enabled: true,
      releaseOnEdges: true,
      forceToAxis: true,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
  });

  const relatedSlider = new Swiper(".js-homes-related", {
    slidesPerView: "auto",
    spaceBetween: 16,
  });

  const projectSlider = new Swiper(".js-project-slider", {
    modules: [Navigation],
    slidesPerView: "auto",
    spaceBetween: 6,
    centeredSlides: true,
    loop: true,
    loopPreventsSliding: true,
    loopAdditionalSlides: 2,
    speed: 600,
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const projectSlides = document.querySelectorAll(
    ".js-project-slider .swiper-slide"
  );

  if (projectSlides.length != 0) {
    projectSlides.forEach((slide) => {
      slide.addEventListener("click", (e) => {
        let index = slide.getAttribute("data-swiper-slide-index");
        let length = projectSlider.slides.length;

        if (index > projectSlider.realIndex) {
          if (index == length - 1 && projectSlider.realIndex == 0) {
            projectSlider.slidePrev();
          } else {
            projectSlider.slideNext();
          }
        } else if (index < projectSlider.realIndex) {
          if (index == 0 && projectSlider.realIndex == length - 1) {
            projectSlider.slideNext();
          } else {
            projectSlider.slideToLoop(index);
          }
        }
      });
    });
  }
};

export default slider;
